import axios, { AxiosResponse } from "axios";
import { api } from "../../data/urls";
import returnAuthHeaderForAJAX from "../auth/returnAuthHeaderForAJAX";

export const upgradeFromFreeAsync = (
  accessToken: string,
  paddlePlanId: number,
  userEmail: string,
): Promise<AxiosResponse<any>> => {
  return new Promise((resolve, reject) => {
    const apiUrl =
      api.account.upgradeFromFreeToPro.prefix +
      paddlePlanId +
      api.account.upgradeFromFreeToPro.postfix;
    axios
      .post(apiUrl, { userEmail }, { ...returnAuthHeaderForAJAX(accessToken) })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
